/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'confluence.error.panel.refresh.app': '앱 새로 고침',
  'confluence.error.panel.reload.page': '페이지 다시 로드',
  'confluence.icon.label': '아이콘',
  'confluence.modal.dialog.close.modal.button': '취소',
  'confluence.select.required.field.message': '이 필드는 필수입니다.',
  'confluence.text.area.required.field.message': '이 필드는 필수입니다.',
  'confluence.textfield.validator.email': '유효한 이메일 주소를 입력하세요.',
  'confluence.textfield.validator.number': '유효한 숫자를 입력하세요',
  'confluence.textfield.validator.required.field.message': '이 필드는 필수입니다.',
  'confluence.textfield.validator.telephone': '유효한 전화번호를 입력하세요.',
  'confluence.threeLOPrompt.modal.access.required.title': '액세스 권한 필요',
  'confluence.threeLOPrompt.modal.error.title': '오류',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    '동의 URL을 찾을 수 없습니다. 페이지를 새로 고친 후 다시 시도하세요.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    '동의 URL을 찾을 수 없습니다. 페이지를 새로 고친 후 다시 시도하세요.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': '액세스 허용',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': '액세스 구성',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': '인증에 실패했습니다.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    '{appString}을(를) 표시하려면 앱이 사용자 대신 Atlassian 제품에 액세스할 수 있도록 허용해야 합니다.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString}에 사용자의 계정에 대한 추가 액세스 권한이 필요합니다.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': '외부 인증 경고',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': '이 앱',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': '이 앱',
  'confluence.user.group.unknown.user.message': '알 수 없는 사용자',
  'confluence.user.picker.empty.field.error.message': '이 필드는 필수입니다.',
  'confluence.user.unknown.user.message': '알 수 없는 사용자',
  'forge-ui.form.submit-button.text': '제출',
};
